import { Container } from '@mui/material';
import React from 'react';
import CustomerDataTable from './customer/CustomerDataTable';

const AdminHomeContent = () => {
  return (
    <Container maxWidth="xxl">
      <CustomerDataTable />
    </Container>
  );
};

export default AdminHomeContent;
